export default {
  label: 'Operação',
  items: {
    sum: 'Soma',
    count: 'Contagem de itens',
    avg: 'Média',
    min: 'Mínimo',
    max: 'Máximo',
    first: 'Primeiro',
    last: 'Último',
    size: 'Contagem de documento',
  },
};
